export const getBuyerName = () => {
    const domainName = window.location.hostname;
    
    // Check for brand=OA in URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const allowedBrands = ['OA', 'Harrington'];
    const brand = allowedBrands.includes(urlParams.get('brand')) ? urlParams.get('brand') : allowedBrands.includes(localStorage.getItem('brand')) ? localStorage.getItem('brand') : '';
    if (brand && brand.trim() !== '') {
        localStorage.setItem('brand', brand);
        return brand;
    }
    // First determine the default buyer based on domain
    let defaultBuyer;
    if ( domainName.includes('lookupfinance.co.uk') || domainName.includes('scanandclaim.co.uk') || domainName.includes('savvyfinances.co.uk' || domainName.includes('myreclaim.co.uk'))) {
        defaultBuyer = 'OA';
    }else if(domainName === 'localhost' ||domainName.includes('optimus-claims.co.uk') || domainName.includes('direct-refunds.co.uk') || domainName.includes('onlinefinanceclaims.co.uk')){
        defaultBuyer = 'Harrington';
    } else {
        defaultBuyer = 'OA';
    }
    localStorage.setItem('brand', defaultBuyer);
    return defaultBuyer;
  };
  